export enum EVENTS {
  /**
   * [Blip Only] Event triggered when the Blip chat widget is fully rendered on the page.
   * This signifies that the widget is ready for interaction.
   */
  ON_BUILD_BLIP_WIDGET = 'build-blip-widget',

  /**
   * [Blip Only] Event triggered by the app-vulcano when the user logs out.
   * This event typically leads to the destruction of the Blip chat widget.
   */
  VULCANO_LOGOUT = 'vulcano-logout',

  /**
   * [Blip Only] Event triggered when the Blip chat widget is opened, either by the user
   * or programmatically. It functions the same as 'app-chat:on-open', signaling that the widget has been opened.
   */
  BLIP_ENTER = 'enter-blip-widget',

  /**
   * Event to programmatically open the chat widget.
   * It can be dispatched to force the widget to open if it is closed.
   */
  CHAT_OPEN = 'app-chat:open',

  /**
   * Event to programmatically close the chat widget.
   * It can be dispatched to force the widget to close if it is open.
   */
  CHAT_CLOSE = 'app-chat:close',

  /**
   * Event to programmatically toggle the chat widget's visibility.
   * If the widget is open, it will close; if it is closed, it will open.
   */
  CHAT_TOGGLE = 'app-chat:toggle',

  /**
   * Event triggered when the chat widget is successfully initialized.
   * This occurs after the `/channel-support-enablement` endpoint is called and responds successfully,
   * signaling that the chat widget is ready for use.
   */
  ON_CHAT_INIT = 'app-chat:on-init',

  /**
   * Event triggered when the chat widget is manually or programmatically opened.
   * It signifies the widget's visibility change to the open state.
   */
  ON_CHAT_OPEN = 'app-chat:on-open',

  /**
   * Event triggered when the chat widget is manually or programmatically closed.
   * It signifies the widget's visibility change to the closed state.
   */
  ON_CHAT_CLOSE = 'app-chat:on-close',

  /**
   * Event triggered whenever the chat widget is toggled between the open and closed states.
   * This event fires both when the widget is opened and when it is closed.
   */
  ON_CHAT_TOGGLE = 'app-chat:on-toggle',

  /**
   * Event to programmatically show the chat widget.
   * It can be dispatched to force the widget to show if it is hidden.
   */
  CHAT_SHOW = 'app-chat:show',

  /**
   * Event to programmatically hide the chat widget.
   * It can be dispatched to force the widget to hide if it is visible.
   */
  CHAT_HIDE = 'app-chat:hide',

  /**
   * Event triggered when the chat widget is shown.
   * It signifies the widget's visibility change to the shown state.
   */
  ON_CHAT_SHOW = 'app-chat:on-show',

  /**
   * Event triggered when the chat widget is hidden.
   * It signifies the widget's visibility change to the hidden state.
   */
  ON_CHAT_HIDE = 'app-chat:on-hide',
}

export enum CHAT_NAMES {
  BLIP_ASYNC_BUYER = 'BLIP_ASYNC_BUYER',
  BLIP_SYNC_CREATOR_FALLBACK = 'BLIP_SYNC_CREATOR_FALLBACK',
  ZENDESK_SYNC_CREATOR = 'ZENDESK_SYNC_CREATOR',
  HOTMART_ASYNC_CREATOR_FALLBACK = 'HOTMART_ASYNC_CREATOR_FALLBACK',
  ZENDESK_ASYNC_CREATOR = 'ZENDESK_ASYNC_CREATOR',
  ZENDESK_CAIO = 'ZENDESK_CAIO',
  ZENDESK_CAIO_SUNSHINE = 'ZENDESK_CAIO_SUNSHINE',
}
